module.exports = __webpack_public_path__ + "img/eyeopen.9d88f68e.svg";